export const checkUrl = (rule, value, callBack) => {
  const text = value
  if (!text) {
    callBack()
    return
  }
  // eslint-disable-next-line no-useless-escape
  const reg = /^http(s)?:\/\/[\w\-]+(\.[\w\-]+)+([\w\-.,@?^=%&:\/~+#]*[\w\-@?^=%&\/~+#])?$/
  if (!reg.test(text)) {
    callBack(`链接格式错误`)
    return
  } else callBack()
}
